/**
 * Triggered when there was an error loading a sound
 * @param {HTMLAudioElement} image the element containing the missing sound
 */
export function opusCheck(
  channel: HTMLAudioElement,
): OnErrorEventHandlerNonNull {
  const audio = channel.src;
  if (audio === "") {
    return;
  }
  let oldsrc = "";
  let newsrc = "";
  oldsrc = channel.src;
  if (!oldsrc.endsWith(".opus")) {
    newsrc = oldsrc.replace(".mp3", ".opus");
    newsrc = newsrc.replace(".wav", ".opus");
    // Only retry if the URL actually changed. Otherwise (e.g. a URL with no
    // audio extension like ".../sounds/music/") re-assigning the same src
    // fails again and re-fires this handler forever, spamming the console.
    if (newsrc !== oldsrc) {
      console.warn(`failed to load sound ${channel.src}`);
      channel.src = newsrc; // unload so the old sprite doesn't persist
    }
  }
}
window.opusCheck = opusCheck;
